import history from 'State/history';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { dashboardUri } from 'Consts/clientUris';

const OnboardingClientDashboardRedirect = () => {
  useComponentDidMount(() => {
    history.push(dashboardUri);
  });

  return null;
};

OnboardingClientDashboardRedirect.defaultProps = {};

OnboardingClientDashboardRedirect.propTypes = {};

export { OnboardingClientDashboardRedirect };
